/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoBannerListRequest model module.
 * @module model/EventsControllerDtoBannerListRequest
 * @version 1.0
 */
class EventsControllerDtoBannerListRequest {
    /**
     * Constructs a new <code>EventsControllerDtoBannerListRequest</code>.
     * @alias module:model/EventsControllerDtoBannerListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     * @param status {Number} 
     */
    constructor(page, pageLength, status) { 
        
        EventsControllerDtoBannerListRequest.initialize(this, page, pageLength, status);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength, status) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
        obj['status'] = status;
    }

    /**
     * Constructs a <code>EventsControllerDtoBannerListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoBannerListRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoBannerListRequest} The populated <code>EventsControllerDtoBannerListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoBannerListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('searchString')) {
                obj['searchString'] = ApiClient.convertToType(data['searchString'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoBannerListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoBannerListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of EventsControllerDtoBannerListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['searchString'] && !(typeof data['searchString'] === 'string' || data['searchString'] instanceof String)) {
            throw new Error("Expected the field `searchString` to be a primitive type in the JSON string but got " + data['searchString']);
        }

        return true;
    }


}

EventsControllerDtoBannerListRequest.RequiredProperties = ["page", "pageLength", "status"];

/**
 * @member {Number} page
 */
EventsControllerDtoBannerListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
EventsControllerDtoBannerListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
EventsControllerDtoBannerListRequest.prototype['skip'] = undefined;

/**
 * @member {Number} status
 */
EventsControllerDtoBannerListRequest.prototype['status'] = undefined;

/**
 * @member {String} searchString
 */
EventsControllerDtoBannerListRequest.prototype['searchString'] = undefined;






export default EventsControllerDtoBannerListRequest;

